import config from '@app/config';
import {
  FullscreenControl,
  GeolocationControl,
  RulerControl,
  SearchControl,
  TrafficControl,
  TypeSelector,
  YMaps,
  ZoomControl,
  Map,
  MapState,
} from 'react-yandex-maps';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { ReactNode } from 'react';

export interface MapTypeProps {
  children: ReactNode;
  options?: MapState;
}

const defaultOption = {
  center: [],
  zoom: 8,
};

export const MapComponent = ({ children, options = defaultOption }: MapTypeProps) => {
  const isMobile = useWindowSizing(990);
  return (
    <YMaps query={{ ns: 'use-load-option', apikey: config.yandexMapsKey }}>
      <Map state={{ ...options, behaviors: ['default', 'scrollZoom'] }} width="100%" height="100%">
        <FullscreenControl options={{ visible: !isMobile }} />
        <GeolocationControl options={{ float: 'left' }} />
        <RulerControl options={{ float: 'right' }} />
        <SearchControl options={{ float: 'left' }} />
        <TrafficControl options={{ float: 'right' }} />
        <TypeSelector options={{ float: 'right' }} />
        <ZoomControl options={{ float: 'left' }} />
        {children}
      </Map>
    </YMaps>
  );
};
